import { LessonForm } from 'components/submit/SubmitForm/types';
import Lesson from 'models/Lesson';
import Database, { LESSONS_DOCUMENT } from './Database';
import { formatFormData } from './utils';

export async function getAllLessons(): Promise<Lesson[]> {
  const snapshot: any = await Database.get().ref(LESSONS_DOCUMENT).once('value');

  return snapshot.val();
}

export async function addLesson(lesson: LessonForm, file: File) {
  const formattedLesson = formatFormData(lesson);

  const { key: recordKey } = Database.get()
    .ref(LESSONS_DOCUMENT)
    .push(formattedLesson, (error: any) => {
      if (error) {
        console.log('Data could not be saved. ' + error);
      } else {
        console.log('Data saved successfully.');
      }
    });

  if (recordKey !== null) {
    addFile(file, recordKey);
  }
}

async function addFile(file: File, recordKey: string) {
  Database.saveFile(file, recordKey);
}

export async function updateLessonApproval(lesson: Lesson, approved: boolean) {
  Database.get()
    .ref(`${LESSONS_DOCUMENT}/${lesson.lessonId}`)
    .set({ ...lesson, submissionApproved: approved }, (error: any) => {
      if (error) {
        console.log('Data could not be saved. ' + error);
      } else {
        console.log('Data saved successfully.');
      }
    });
}

export async function deleteLesson(id: string) {
  Database.get().ref(`${LESSONS_DOCUMENT}/${id}`).remove();
}
